// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"64059055","787":"114c1552"}[chunkId] + ".chunk.js";
};